import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    const initializeBlock = function() {
        var splideElements = document.querySelectorAll('.photo-gallery-section__bna__slider');

        if (splideElements.length > 0) {
            splideElements.forEach(function (splideElement) {
                // Destroy existing instance if already initialized
                if (splideElement.splide) {
                    splideElement.splide.destroy();
                }

                const counter = splideElement.querySelector('.slider-info .slider-numbers');
                const perPage = parseInt(splideElement.getAttribute('data-per-page')) || 1;

                var splide = new Splide(splideElement, {
                    type: 'slider',
                    speed: 1000,
                    arrows: true,
                    pagination: false,
                    rewind: false,
                    perPage: perPage,
                    perMove: 1,
                    gap: 10,
                    waitForTransition: false,
                    arrowPath: 'M4.88 8.75L5.54 8L2.02 4.87L16.71 4.87L16.71 3.87L2.03 3.87L5.55 0.74L4.89 -0.0099998C4.81 0.0700001 -0.170002 4.47 0.00999871 4.36C-0.160001 4.28 4.78 8.64 4.89 8.73L4.88 8.75Z',
                    breakpoints: {
                        768: {
                            perPage: 1,
                        }
                    }
                });

                splide.mount();

                // Keep a reference for cleanup
                splideElement.splide = splide;

                // Counter function
                function updateCounter(splide) {
                    if (counter) {
                        var currentSlide = splide.index + 1;
                        var totalSlides = splide.length;
                        counter.textContent = `${currentSlide}/${totalSlides}`;
                    }
                }

                updateCounter(splide);
                splide.on('move', function () {
                    updateCounter(splide);
                });
            });
        }
    }
    
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=photo-gallery-section', initializeBlock);
    } else {
        initializeBlock();
    }
});
